import { createFileRoute, Link } from '@tanstack/react-router'
import { RootLayout } from '@/components/layout/RootLayout'
import { GlassCard } from '@/components/ui/GlassCard'
import { Settings, Server, Building2, ChevronRight, Network, KeyRound, Waypoints, Radio } from 'lucide-react'
import { useT } from '@/i18n/provider'

export const Route = createFileRoute('/settings/')({
  component: SettingsIndexPage,
})

const SETTINGS_LINKS = [
  {
    to: '/settings/providers' as const,
    icon: Server,
    titleKey: 'settings.index.modelProvidersTitle' as const,
    descriptionKey: 'settings.index.modelProvidersDescription' as const,
  },
  {
    to: '/settings/organization' as const,
    icon: Building2,
    titleKey: 'settings.index.organizationTitle' as const,
    descriptionKey: 'settings.index.organizationDescription' as const,
  },
  {
    to: '/settings/workspaces' as const,
    icon: Network,
    titleKey: 'settings.index.workspacesTitle' as const,
    descriptionKey: 'settings.index.workspacesDescription' as const,
  },
  {
    to: '/settings/channels' as const,
    icon: Radio,
    titleKey: 'settings.index.channelsTitle' as const,
    descriptionKey: 'settings.index.channelsDescription' as const,
  },
  {
    to: '/settings/ops/secrets' as const,
    icon: KeyRound,
    titleKey: 'settings.index.opsSecretsTitle' as const,
    descriptionKey: 'settings.index.opsSecretsDescription' as const,
  },
  {
    to: '/settings/ops/hosting' as const,
    icon: Server,
    titleKey: 'settings.index.opsHostingTitle' as const,
    descriptionKey: 'settings.index.opsHostingDescription' as const,
  },
  {
    to: '/settings/ops/channels' as const,
    icon: Waypoints,
    titleKey: 'settings.index.opsChannelsTitle' as const,
    descriptionKey: 'settings.index.opsChannelsDescription' as const,
  },
]

function SettingsIndexPage() {
  const t = useT()

  return (
    <RootLayout>
      <div className="space-y-6 max-w-2xl">
        <div className="flex items-center gap-3">
          <Settings size={22} className="text-[var(--oc-accent-light)]" />
          <div>
            <h1 className="text-2xl font-bold text-white">{t('settings.index.title')}</h1>
            <p className="text-sm text-white/40 mt-0.5">{t('settings.index.subtitle')}</p>
          </div>
        </div>

        <div className="space-y-3">
          {SETTINGS_LINKS.map(({ to, icon: Icon, titleKey, descriptionKey }) => (
            <Link key={to} to={to}>
              <GlassCard hover className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-[var(--oc-accent)]/15 border border-[var(--oc-accent)]/25 flex items-center justify-center flex-shrink-0">
                  <Icon size={20} className="text-[var(--oc-accent-light)]" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-white">{t(titleKey)}</p>
                  <p className="text-xs text-white/45 mt-0.5">{t(descriptionKey)}</p>
                </div>
                <ChevronRight size={16} className="text-white/30" />
              </GlassCard>
            </Link>
          ))}
        </div>
      </div>
    </RootLayout>
  )
}
